import { component } from "picoapp";
import $ from "jquery";
import "slick-carousel";

export default component((node, ctx) => {
  const slider = node.querySelector(".js-slider");

  if (slider) {
    $(slider).slick({
      dots: true,
      arrows: false,
      draggable: true,
      swipe: true,
      fade: true,
    });
  }
});
